export const formatSecondsToHHMMSS = (seconds: number): string => {
  if (seconds < 3600) {
    return new Date(Math.floor(seconds) * 1000).toISOString().substring(14, 19);
  }
  return new Date(Math.floor(seconds) * 1000).toISOString().substring(11, 19);
};
